// types.js
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const SET_ERROR = 'SET_ERROR';
export const UPDATE_USER_SETTINGS = 'UPDATE_USER_SETTINGS';
